import {
  currentUser, refreshEmailVerification, resendEmailVerification, signOutUser,
} from '../lib/auth.js';
import { navigate } from '../router.js';
import { brandMarkHtml } from '../components/brandMark.js';
import { humanizeAuthError } from '../lib/friendlyError.js';

// A signed-in email/password user reaches this screen until Firebase reports
// that the one-time link sent at registration has been used.
export function renderVerifyEmail(container) {
  const user = currentUser();
  if (!user) { navigate('/login'); return; }

  container.innerHTML = `
    <div class="center-screen">
      <div class="auth-card">
        <h1 style="display:flex;align-items:center;justify-content:center;gap:10px;">${brandMarkHtml()} Check your email</h1>
        <p style="text-align:center;color:var(--text-dim);line-height:1.55;">
          We sent a verification link to <strong>${escapeHtml(user.email || '')}</strong>.
          Open it to complete your registration, then return here.
        </p>
        <div id="verification-status" role="status" style="min-height:22px;text-align:center;font-size:0.84rem;margin:16px 0;"></div>
        <button class="btn btn-primary" id="verified-btn" style="width:100%;justify-content:center;">I've verified my email</button>
        <button class="btn" id="resend-btn" style="width:100%;justify-content:center;margin-top:10px;">Resend verification email</button>
        <button class="btn" id="signout-btn" style="width:100%;justify-content:center;margin-top:10px;">Use a different account</button>
      </div>
    </div>
  `;

  const status = container.querySelector('#verification-status');
  const setStatus = (message, color = 'var(--text-dim)') => {
    status.textContent = message;
    status.style.color = color;
  };

  container.querySelector('#verified-btn').addEventListener('click', async (event) => {
    const button = event.currentTarget;
    button.disabled = true;
    setStatus('Checking your verification…');
    try {
      if (await refreshEmailVerification()) {
        navigate('/');
      } else {
        setStatus('Your email is not verified yet. Open the link we sent, then try again.', 'var(--danger)');
      }
    } catch (err) {
      setStatus(humanizeAuthError(err), 'var(--danger)');
    } finally {
      button.disabled = false;
    }
  });

  container.querySelector('#resend-btn').addEventListener('click', async (event) => {
    const button = event.currentTarget;
    button.disabled = true;
    setStatus('Sending verification email…');
    try {
      await resendEmailVerification();
      setStatus('A new verification link has been sent.', 'var(--success)');
    } catch (err) {
      setStatus(humanizeAuthError(err), 'var(--danger)');
    } finally {
      button.disabled = false;
    }
  });

  container.querySelector('#signout-btn').addEventListener('click', async () => {
    await signOutUser();
    navigate('/login');
  });
}

function escapeHtml(value) {
  const span = document.createElement('span');
  span.textContent = value;
  return span.innerHTML;
}
